const AUTH_RETURN_URL_KEY = "auth_return_url";

function sanitizeReturnPath(path: string): string {
	if (path.startsWith("/") && !path.startsWith("//")) return path;
	return "/";
}

/** Сохранить путь возврата после SSO (относительный URL). */
export function writeAuthReturnUrl(path: string): void {
	try {
		window.localStorage.setItem(AUTH_RETURN_URL_KEY, sanitizeReturnPath(path));
	} catch {
		/* приватный режим */
	}
}

/** Прочитать сохранённый путь без удаления. */
export function readAuthReturnUrl(): string {
	try {
		const raw = window.localStorage.getItem(AUTH_RETURN_URL_KEY);
		if (raw) return sanitizeReturnPath(raw);
	} catch {
		/* приватный режим */
	}
	return "/";
}

/** Прочитать и удалить сохранённый путь (одноразовое использование после SSO). */
export function consumeAuthReturnUrl(): string {
	const path = readAuthReturnUrl();
	try {
		window.localStorage.removeItem(AUTH_RETURN_URL_KEY);
	} catch {
		/* приватный режим */
	}
	return path;
}

/** Landing URL после native SSO: returnPath + маркер `from=sso` для AuthProvider. */
export function buildSsoReturnLocation(returnPath?: string): string {
	const safe = sanitizeReturnPath(returnPath ?? readAuthReturnUrl());
	const qIndex = safe.indexOf("?");
	const pathname = qIndex >= 0 ? safe.slice(0, qIndex) : safe;
	const existing = qIndex >= 0 ? safe.slice(qIndex + 1) : "";
	const params = new URLSearchParams(existing);
	params.set("from", "sso");
	const qs = params.toString();
	return `${pathname}?${qs}`;
}
